import React from 'react';
import { FaCheck } from 'react-icons/fa';
import './style.css';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import { FORM_TYPE } from '../../IPlushelper';
import { buildAutomationChildTestId, resolveAutomationTestId } from '../../../../../components/InputField/testId';

const JourneySteps = ({
    isKYCComplete = false,
    type = "horizontal",
    formType,
    isForEdd,
    requiredUboIds,
    isKycRequired = true,
    isBrokerSession = false,
    testId,
}) => {
    const { t } = useTranslation();
    const isKycSatisfied = !isKycRequired || isKYCComplete;
    const resolvedTestId = resolveAutomationTestId(testId);

    return (
        <div className="fv_application_journey_container" data-testid={resolvedTestId}>
            <div className={`fv_application_journey_steps ${type}`} data-testid={buildAutomationChildTestId(resolvedTestId, "steps")}>
                <div className={`fv_application_journey_step ${type} fv_application_journey_step--completed`} data-testid={buildAutomationChildTestId(resolvedTestId, "step-application-submission")}>
                    <div className={`fv_application_journey_step_circle ${type}`}>
                        <FaCheck className="fv_application_journey_step_icon" />
                    </div>
                    <div className="fv_application_journey_content">
                        <h4 className="fv_application_journey_title">{t("Application Submission")}</h4>
                        <p className="fv_application_journey_desc">{t(`Thank you for submitting the ${isForEdd ? "Periodic Review" : "application"}.`)}</p>
                    </div>
                </div>


                <div className={`fv_application_journey_step ${type} ${isKycSatisfied ?
                    'fv_application_journey_step--completed' :
                    'fv_application_journey_step--current'
                    }`} data-testid={buildAutomationChildTestId(resolvedTestId, "step-kyc-completion")}>
                    <div className={`fv_application_journey_step_circle ${type}`}>
                        {isKycSatisfied ? (
                            <FaCheck className="fv_application_journey_step_icon" />
                        ) : (
                            <span className="fv_application_journey_step_number">2</span>
                        )}
                    </div>
                    <div className="fv_application_journey_content">
                        <h4 className="fv_application_journey_title">{t("KYC Completion")}</h4>
                        <p className="fv_application_journey_desc">
                            {
                                !isKycRequired
                                    ? t("KYC is not required for this application.")
                                    : isKycSatisfied
                                    ? t([FORM_TYPE.BusinessPlus, FORM_TYPE.BusinessPrime, FORM_TYPE.Business]?.includes(formType) ?
                                        isForEdd && !requiredUboIds?.length ? "KYC not required due to unchanged identity information." : "All Users have completed KYC verification" :
                                        "Thank you for completing your KYC.")
                                    : t([FORM_TYPE.BusinessPlus, FORM_TYPE.BusinessPrime, FORM_TYPE.Business]?.includes(formType) ?
                                        "Please follow up with all users to ensure KYCs are complete" :
                                        "Please complete your KYC.")
                            }
                        </p>
                    </div>
                </div>

                <div className={`fv_application_journey_step ${isKycSatisfied ? "fv_application_journey_step--current" : ""} ${type} `} data-testid={buildAutomationChildTestId(resolvedTestId, "step-follow-up-responses")}>

                    <div className={`fv_application_journey_step_circle ${type}`}>
                        <span className="fv_application_journey_step_number">3</span>
                    </div>
                    <div className="fv_application_journey_content">
                        <h4 className="fv_application_journey_title">{t("Follow-up Responses")}</h4>
                        <p className="fv_application_journey_desc">{t("Agents will reach out if they need more information")}</p>
                    </div>
                </div>

                <div className={`fv_application_journey_step ${type} `} data-testid={buildAutomationChildTestId(resolvedTestId, "step-receive-credentials")}>

                    <div className={`fv_application_journey_step_circle ${type}`}>
                        <span className="fv_application_journey_step_number">4</span>
                    </div>
                    <div className="fv_application_journey_content">
                        <h4 className="fv_application_journey_title">{t(isForEdd ? "Profile Updated" : isBrokerSession ? "Ready to Transact" : "Receive Credentials")}</h4>
                        <p className="fv_application_journey_desc">
                            {isForEdd ? (
                                t("The new self-declaration will be in effect")
                            ) : isBrokerSession ? (
                                // Broker-managed: the broker is not the account holder, so we don't
                                // promise "you" credentials or link the client's FV Bank portal here.
                                t("Once approved, your client's account will be ready to transact.")
                            ) : (
                                <>
                                    {t("You will receive credentials on separate emails for the")}
                                    <a href="https://portal.fvbank.us" className="fv_application_journey_link" data-testid={buildAutomationChildTestId(resolvedTestId, "portal-link")}>
                                        {" "}  {t("portal")}
                                    </a>
                                </>
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JourneySteps
